import React, {createContext, useReducer} from 'react'
import {AssociateDetailReducer} from "../reducers/AssociateDetailReducer";

export const AssociateContext = createContext()

const AssociateContextProvider = (props) => {
    const state = {
        associate: []
    }
    const [ associateViewModel, associateModelDispatcher ] = useReducer(AssociateDetailReducer, state)
    return (
        <AssociateContext.Provider value = {{associateViewModel, associateModelDispatcher}}>
            {props.children}
        </AssociateContext.Provider>
    )
}

export default AssociateContextProvider


// WEBPACK FOOTER //
// ./src/components/associate/context/AssociateContextProvider.js